import React from 'react';
import { Container } from 'react-bootstrap';
import whatsappLogo from '../images/whatsapp-logo.png';

const HeroSection = () => {
    return (
        <div className="bg-light d-flex justify-content-center align-items-center p-5 w-100 mt-5" style={{height: '200px'}}>
            <Container className="d-flex flex-wrap justify-content-center align-items-center gap-2 beba-font h2 m-0">
                <span className="m-0">¡Asesórate gratis!</span>
                <a
                    href="https://wa.link/u8ucah"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="d-flex align-items-center gap-2 text-decoration-none"
                >
                    <img src={whatsappLogo} alt="WhatsApp" height="32" width="32" />
                    <span className="fw-bold" style={{ color: '#25D366' }}>WHATSAPP</span>
                </a>
            </Container>
        </div>
    );
};

export default HeroSection;
